<template>
  <div class="footer p-5">
    <div class="container">
      <div class="row">
        <div class="col-md-4">
          <img src="/img/logo.png" />
          <h5 class="mt-3">سامانه سفارش آنلاین غذا</h5>
        </div>
        <div class="col-md-4">
          <ul class="nav flex-column">
            <li class="nav-item">
              <a class="nav-link active" href="#">تماس با ما</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#">درباره ما</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#">قوانین مقررات</a>
            </li>
            
          </ul>
        </div>
        <div class="col-md-4"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "footer-component",
  data() {
    return {
      base_url: process.env.VUE_APP_API_URL,
    };
  },
};
</script>

<style lang="scss" scoped>
.footer {
  background: #00304e;
  color: white;
  margin-top: auto;
  margin-bottom: 45px;
}

.footer a.nav-link {
    color: #fff;
}
</style>
